import React from 'react';
import clsx from 'clsx'; // Recommended for conditional classes

interface OPAAvatarProps {
  imageUrl?: string;
  size?: number;
  borderWidth?: number;
  borderColor?: string;
  borderGradient?: {
    colors: string[];
    direction?: 'to-b' | 'to-r' | 'to-t' | 'to-l';
  };
  className?: string;
  children?: React.ReactNode;
}

export const OPAAvatar: React.FC<OPAAvatarProps> = ({
  imageUrl,
  size = 48,
  borderWidth = 0,
  borderColor,
  borderGradient,
  className,
  children
}) => {
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  const gradientClasses = borderGradient && {
    'bg-gradient-to-b': borderGradient.direction === 'to-b' || !borderGradient.direction,
    'bg-gradient-to-r': borderGradient.direction === 'to-r',
    'bg-gradient-to-t': borderGradient.direction === 'to-t',
    'bg-gradient-to-l': borderGradient.direction === 'to-l',
    'from-[var(--gradient-from)]': true,
    'to-[var(--gradient-to)]': true,
  };

  return (
    <div
      className={clsx(
        'rounded-full overflow-hidden',
        gradientClasses,
        className
      )}
      style={{
        width: size,
        height: size,
        padding: borderWidth,
        ...(borderGradient && {
          '--gradient-from': borderGradient.colors[0],
          '--gradient-to': borderGradient.colors[1],
        } as React.CSSProperties),
        ...(borderColor && {
          backgroundColor: borderColor,
        })
      }}
    >
      <div className="w-full h-full rounded-full overflow-hidden">
        {imageUrl && (
          <div className="relative w-full h-full">
            {/* Transparent placeholder */}
            <div
              className={clsx(
                'absolute w-full h-full bg-transparent transition-opacity duration-200',
                isImageLoaded ? 'opacity-0' : 'opacity-100'
              )}
            />
            <img
              src={imageUrl}
              alt="avatar"
              onLoad={() => setIsImageLoaded(true)}
              className={clsx(
                'w-full h-full object-cover transition-opacity duration-200',
                isImageLoaded ? 'opacity-100' : 'opacity-0'
              )}
              width={150}
              height={150}
              loading="lazy"
            />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};